module.exports = __webpack_public_path__ + "media/images/icons/material/plus-4ab86fc6100902ab8b8febdf2ce21a95.svg";